import { toast } from 'react-toastify'

export const openErrorToaster = ({ message, toasterId = '' }) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openSuccessToaster = ({ message, toasterId = '' }) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openInfoToaster = ({ message, toasterId = '' }) => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openWarningToaster = ({ message, toasterId = '' }) => {
  toast.warn(message, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}
